import { PassouFalhouEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { hasAnySim, isAllFilled, isAllNao } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { isEmpty } from 'util/checks'

import {
  ConsultaSeguimentoPergunta01ExemplosEnum,
  ConsultaSeguimentoPergunta01Model,
} from './model-consultaSeguimentoPergunta01'

const pergunta01ExemplosPassouEnumValues = [
  ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_PARA_OBJETO,
  ConsultaSeguimentoPergunta01ExemplosEnum.APONTA_PARA_OBJETO,
  ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_E_COMENTA_SOBRE_OBJETO,
  ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_QUANDO_GENITOR_APONTA,
]
const pergunta01ExemplosFalhouEnumValues = [
  ConsultaSeguimentoPergunta01ExemplosEnum.IGNORA_VOCE,
  ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_AO_REDOR,
  ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_PARA_DEDO_DO_GENITOR,
]

export function isPergunta01ExemplosAllFilled(
  value: ConsultaSeguimentoPergunta01Model['PERGUNTA_01_EXEMPLOS']
): boolean {
  return (
    isAllFilled(value?.PASSOU, pergunta01ExemplosPassouEnumValues) &&
    isAllFilled(value?.FALHOU, pergunta01ExemplosFalhouEnumValues)
  )
}

export function isPergunta01ExemplosAllNao(value: ConsultaSeguimentoPergunta01Model['PERGUNTA_01_EXEMPLOS']): boolean {
  return (
    isAllNao(value?.PASSOU, pergunta01ExemplosPassouEnumValues) &&
    isAllNao(value?.FALHOU, pergunta01ExemplosFalhouEnumValues)
  )
}

export function hasPergunta01ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta01Model['PERGUNTA_01_EXEMPLOS']
): boolean {
  return hasAnySim(value?.PASSOU)
}

export function hasPergunta01ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta01Model['PERGUNTA_01_EXEMPLOS']
): boolean {
  return hasAnySim(value?.FALHOU)
}

export function prunePergunta01(value: ConsultaSeguimentoPergunta01Model): ConsultaSeguimentoPergunta01Model {
  const pruned: ConsultaSeguimentoPergunta01Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_01_HEADER: value.PERGUNTA_01_HEADER,
    PERGUNTA_01_EXEMPLOS: value.PERGUNTA_01_EXEMPLOS,
  }

  const hasPerguntaExemplosPassouAnySim = hasPergunta01ExemplosPassouAnySim(value.PERGUNTA_01_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta01ExemplosFalhouAnySim(value.PERGUNTA_01_EXEMPLOS)

  if (hasPerguntaExemplosPassouAnySim && hasPerguntaExemplosFalhouAnySim) {
    pruned.PERGUNTA_01_MAIOR_FREQUENCIA = value.PERGUNTA_01_MAIOR_FREQUENCIA
  }

  return pruned
}

export function conditionToCalculatePergunta01(values: ConsultaSeguimentoPergunta01Model): boolean {
  if (
    !isPergunta01ExemplosAllFilled(values?.PERGUNTA_01_EXEMPLOS) ||
    isPergunta01ExemplosAllNao(values?.PERGUNTA_01_EXEMPLOS)
  ) {
    return false
  }

  const hasPerguntaExemplosPassouAnySim = hasPergunta01ExemplosPassouAnySim(values?.PERGUNTA_01_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta01ExemplosFalhouAnySim(values?.PERGUNTA_01_EXEMPLOS)

  if (
    (hasPerguntaExemplosPassouAnySim && !hasPerguntaExemplosFalhouAnySim) ||
    (hasPerguntaExemplosFalhouAnySim && !hasPerguntaExemplosPassouAnySim)
  ) {
    return true
  } else {
    return !isEmpty(values.PERGUNTA_01_MAIOR_FREQUENCIA)
  }
}

export function calculateResultadoPergunta01(values: ConsultaSeguimentoPergunta01Model): PassouFalhouEnum | undefined {
  const hasPerguntaExemplosPassouAnySim = hasPergunta01ExemplosPassouAnySim(values?.PERGUNTA_01_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta01ExemplosFalhouAnySim(values?.PERGUNTA_01_EXEMPLOS)

  if (hasPerguntaExemplosPassouAnySim && !hasPerguntaExemplosFalhouAnySim) {
    return PassouFalhouEnum.PASSOU
  } else if (hasPerguntaExemplosFalhouAnySim && !hasPerguntaExemplosPassouAnySim) {
    return PassouFalhouEnum.FALHOU
  } else {
    return values.PERGUNTA_01_MAIOR_FREQUENCIA
  }
}
